import { FlexContainer, Text, palette } from '@busie/ui-kit'
import { styled } from '@mui/material/styles'

export const ModalContainer = styled(FlexContainer)({
  width: '1024px',
  maxWidth: '1024px',
  minWidth: '1024px',
  backgroundColor: palette.black.plus100,
  padding: '47px 55px',
  boxShadow: '0px 8px 24px rgba(34, 34, 34, 0.15)',
  borderRadius: '8px',
  height: '90vh',
})

export const Title = styled(Text)({
  fontWeight: 500,
  fontSize: '25px',
  lineHeight: '100%',
})

export const ManeuversContainer = styled(FlexContainer)({
  maxHeight: '30vh',
  overflowX: 'hidden',
  overflowY: 'auto',
})

export const Divider = styled('span')({
  width: '100%',
  height: '1px',
  backgroundColor: palette.black.plus70,
  marginTop: '2rem',
})

export const VerticalDivider = styled('span')({
  height: '100%',
  width: '.25px',
  backgroundColor: palette.black.plus70,
})

export const MetricsValue = styled(Text)({
  fontWeight: 500,
  fontSize: '25px',
  lineHeight: '25px',
})

export const MetricsLabel = styled(Text)({
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '18px',
  color: palette.black.plus40,
})

export const Clickable = styled('span')({
  cursor: 'pointer',
})
